import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';

import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import { AuthService } from 'src/app/core/services/auth.service';

import { GenericPaymentFormService } from 'src/app/core/services/generic-payment-form.service';

@Injectable({
  providedIn: 'root'
})
export class CertificationMainService extends BaseProvider {
	requirements: any = [];
	filteredRequirements: any = [];

	certificationToShow: any;
	certificationToShowPayment: any;

	successMessage: {
		message: any,
		blob: any
	};

	paymentForm: any;
	certificateList: any = [];
	documentList: any = [];

	files: any = [
		{
			cert: "death",
			files: [
				{
					id: 1,
					name: "Identificación con Foto/Photo ID"	
				},
				{
					id: 2,
					name: "Formulario DoD 214/DoD Form 214"
				}
			]		
		}
	];


	status: any = [
		{
			value: "S",
			label: "Sometido"
		},
		{
			value: "A",
			label: "Aprobado"
		},
		{
			value: "D",
			label: "Denegado"
		}
	]

	filesToUpload: any = [];

	price: any = 10;
	pricePerCopy: any = 10;

	copyPrice: any = 0;
	copyAmount: any = 0;

	fee: any = 2;
	states: any = [];
	countries: any = [];
	cities: any = [];

	isInternal: boolean = false;

  	constructor(  		
		public globals: GlobalsService,
 		public http: HttpClient,	
 		public ls: LsHelperService,
 		public authService: AuthService,
 		public genericPaymentFormService: GenericPaymentFormService
  	) { 
		super();
		
		this.baseUrl = "certifications";		
	}	

	getRequirements(){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/requirements';

			this.http
			.get(this.url)
			.subscribe(
			    (data: any) => {
			    	this.requirements = data.Data;

					resolve(data.Data);
			    },
			    err => {reject(err)}
			);
		});    
	}    	

	getUserCertificationDetail(userCertificationId){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + `/detail/${userCertificationId}`;

			this.http
			.get(this.url)
			.subscribe(
			    (data: any) => {			    	
					resolve(data.Data);
			    },
			    err => {reject(err)}
			);
		});    
	}    		

	getUserCertification(){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl;

			this.http
			.get(this.url)
			.subscribe(
			    (data: any) => {			    	
					resolve(data.Data);
			    },
			    err => {reject(err)}
			);
		});    
	}    		

	getFee(){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + '/fee';

			this.http
			.get(this.url)
			.subscribe(
			    (data: any) => {
			    	this.genericPaymentFormService.feeAmount = data.Data;

					resolve(data.Data);
			    },
			    err => {reject(err)}
			);
		});    
	}   	

	filterRequirements(profileType){
		this.filteredRequirements = this.requirements.filter((requirment)=>{
			return requirment.ProfileTypeId == profileType || requirment.ProfileTypeId == 3;
		});
	}

	startCertifications(params){
	    return new Promise( (resolve, reject) => {
	      this.url = this.globals.dataUrl + this.baseUrl;

	        this.http
	        .post(
	          this.url, 
	          params
	        )
	        .subscribe(
	            (data: any) => {
	                resolve(data);
	            },
	            err => {reject(err)}
	        );
	    });     		
	}	

	startCertificationsRequirement(certTransactionId){
	    return new Promise( (resolve, reject) => {
	      this.url = this.globals.dataUrl + this.baseUrl + "/" + certTransactionId;

	        this.http
	        .post(
	          this.url, 
	          null
	        )
	        .subscribe(
	            (data: any) => {
	                resolve(data.Data);
	            },
	            err => {reject(err)}
	        );
	    });     		
	}	

	remove(id){
	    return new Promise( (resolve, reject) => {
	      this.url = this.globals.dataUrl + this.baseUrl;

	        this.http
	        .delete(
	          this.url
	        )
	        .subscribe(
	            (data: any) => {
	                resolve(data);
	            },
	            err => {reject(err)}
	        );
	    });     		
	}		

	getCertification(userCertificationId){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + `/detail/${userCertificationId}/print`;

			this.http
			.get(this.url)
			.subscribe(
			    (data: any) => {
					 
			    },
			    err => {reject(err)}
			);
		});    
	}  




	//Added to prevent error
	createRequest(params){
		return new Promise( (resolve, reject) => {
		    this.url = this.globals.dataUrl + "certificate";

		    this.http
		    .post(
		      this.url, 
		      params
		    )
		    .subscribe(
		        (data: any) => {
		        	resolve(data.Data)
		        },
		        err => {reject(err)}
		    );
		});	
	}	

	createDRTHRequest(params){
		return new Promise( (resolve, reject) => {
		    this.url = this.globals.dataUrl + "certificateDTRH";

		    this.http
		    .post(
		      	this.url, 
		     	params,
		      	{
			    	responseType: "blob",	
		    	}
		    )
		    .subscribe(
		        (data: any) => {
		        	resolve(data)
		        },
		        err => {
		        	reject(err)
		       	}
		    );
		});	
	}

	createASUMEIndividualRequest(params){
		return new Promise( (resolve, reject) => {
		    this.url = this.globals.dataUrl + "certificateAsume/individual";

		    this.http
		    .post(
		      this.url, 
		      params
		    )
		    .subscribe(
		        (data: any) => {
		        	resolve(data)
		        },
		        err => {reject(err)}
		    );
		});	
	}

	createASUMEEmployerRequest(params){
		return new Promise( (resolve, reject) => {
		    this.url = this.globals.dataUrl + "certificateAsume/employer";

		    this.http
		    .post(
		      this.url, 
		      params
		    )
		    .subscribe(
		        (data: any) => {
		        	resolve(data)
		        },
		        err => {reject(err)}
		    );
		});	
	}

	updateRequest(params){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + "certificate/" + params.Id + "/newStatus/" + params.StatusId;

		    this.http
		    .put(this.url, params)
		    .subscribe(
		        (data: any) => {
		        	resolve(data);
		        },
		        err => {reject(err)}
		    );
		});			
	}		

	getCertificate(id){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + "certificate" + 
						'/' + id

		    this.http
		    .get(this.url)
		    .subscribe(
		        (data: any) => {
		        	this.certificationToShow = data.Data;
		        	resolve(data.Data);
		        },
		        err => {reject(err)}
		    );
		});		
	}

	setExpirationDate() {
		
		var splitDateObj = {
			ExpirationMonth: parseInt(this.paymentForm.get('ExpirationDate').value.substring(0,2)),
			ExpirationYear: parseInt(this.paymentForm.get('ExpirationDate').value.substring(2,6))
		};

		this.paymentForm.patchValue(splitDateObj);					
	}
  
}
